import { Zap } from "lucide-react";
import { company } from "@/lib/mockData";

export default function RunwayWidget() {
  // Visualize runway: 12 months = full bar; cap to 0..1.
  const fill = Math.max(0, Math.min(1, company.runwayMonths / 12));

  return (
    <div
      data-testid="runway-widget"
      className="rounded-3xl bg-[#0B0B0E] p-4 text-white shadow-[0_10px_30px_-12px_rgba(0,0,0,0.45)]"
    >
      <div className="flex items-center justify-between">
        <div className="eyebrow text-white/55">Runway</div>
        <div className="flex items-center gap-1 rounded-full bg-emerald-400/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-300">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400 idea-dot-pulse" />
          Live
        </div>
      </div>

      <div className="mt-3 flex items-baseline gap-1">
        <div
          data-testid="runway-months"
          className="text-[34px] font-extrabold leading-none tracking-tight"
        >
          {company.runwayMonths.toFixed(1)}
        </div>
        <div className="text-[13px] font-semibold text-white/65">mo</div>
      </div>
      <div className="mt-1 text-[11px] leading-snug text-white/55">
        @ current burn · {company.burn}
      </div>

      {/* gradient progress */}
      <div className="mt-3 h-[5px] w-full overflow-hidden rounded-full bg-white/10">
        <div
          className="h-full rounded-full"
          style={{
            width: `${fill * 100}%`,
            background:
              "linear-gradient(90deg, #ffffff 0%, #a78bfa 55%, #22d3ee 100%)",
          }}
        />
      </div>

      <div className="mt-3 flex items-center justify-between text-[10px] text-white/45">
        <div className="flex items-center gap-1">
          <Zap className="h-3 w-3" strokeWidth={2.4} />
          <span>Auto-tracked</span>
        </div>
        <span>12mo cap</span>
      </div>
    </div>
  );
}
